module.exports = __webpack_public_path__ + "img/AI.43db0fc3.png";